<template>
  <v-card
    class="d-flex flex-wrap mb-2"
    :color="itemRowBackground(diaSemana)">
    <v-col class="mb-0 pb-0">
      <v-switch
        v-model="item.enabled"
        :label="descricaoDiaSemana(diaSemana)"
        color="primary"
        inset
      />
    </v-col>
    <v-col v-if="item.enabled" class="mb-0 pb-0">
      <v-text-field
        label="Hora início"
        v-model="item.horaInicio"
        type="time"
        outlined
        min=0
        max=24
        v-mask="['##:##']"
        hide-details="auto"
      ></v-text-field>
    </v-col>
    <v-col v-if="item.enabled">
      <v-text-field
        label="Hora Fim"
        v-model="item.horaFim"
        type="time"
        outlined
        min=0
        max=24
        v-mask="['##:##']"
        hide-details="auto"
      ></v-text-field>
    </v-col>
  </v-card>
</template>

<script>
import diasSemana from '@/enums/day-of-week';

export default {
  props: {
    item: Object,
    diaSemana: String,
  },
  methods: {
    descricaoDiaSemana(key) {
      return diasSemana.keys[key].description;
    },
    itemRowBackground(key) {
      return diasSemana.keys[key].color;
    },
  },
  computed: {},
};
</script>
